/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { WVCall } from '../../../bridges/windvane/index.js';
import '../../../bridge-adpter-api-0316c034.js';
import '../../../tslib.es6-e01eabb2.js';

function previewImage(params) {
    var formatInput = function (_a) {
        var urls = _a.urls, current = _a.current;
        return ({
            images: urls,
            index: Number(current || 0),
        });
    };
    WVCall('WVUIImagepreview.showImagepreview', params, { formatInput: formatInput });
}

export { previewImage as default };
